import script from "./RoomObjectGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomObjectGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./RoomObjectGroupModal.vue?vue&type=style&index=0&id=474d888e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474d888e"]])

export default __exports__